import React from "react";
import clsx from "clsx";
import { View, Text } from "../base";
import { Icon } from "../base/Icon";
import { SearchResult } from "./types";

interface CommandPaletteItemProps {
  item: SearchResult;
  isSelected: boolean;
  onClick: () => void;
}

export const CommandPaletteItem: React.FC<CommandPaletteItemProps> = ({ item, isSelected, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left",
        "transition-colors duration-100",
        isSelected
          ? "bg-brand/10 dark:bg-brand/20 text-gray-900 dark:text-white"
          : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50",
      )}
    >
      <View
        className={clsx(
          "flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-md",
          isSelected ? "bg-brand/20 dark:bg-brand/30" : "bg-gray-100 dark:bg-gray-700",
        )}
      >
        <Icon
          name={item.icon}
          size={18}
          className={isSelected ? "text-brand" : "text-gray-500 dark:text-gray-400"}
        />
      </View>
      <View className="flex-1 min-w-0">
        <Text className={clsx("text-sm font-medium truncate mr-1", isSelected ? "text-gray-900 dark:text-white" : "text-gray-900 dark:text-gray-100")}>
          {item.title}
        </Text>
      </View>
      {isSelected && (
        <View className="flex-shrink-0 text-xs text-gray-400 dark:text-gray-500">
          <kbd className="px-1.5 py-0.5 bg-gray-200 dark:bg-gray-600 rounded text-[10px]">↵</kbd>
        </View>
      )}
    </button>
  );
};
